import { Injectable, inject } from '@angular/core';

import type { OrderDetails, OrderSummary, Position, TripStatus } from '@asset-solutions/customer-portal/orders/models';
import { HttpService } from '@asset-solutions/shared/http';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private apiPath = '/orders';
  private httpService = inject(HttpService);

  public getOrderDetails(orderId: number): Observable<OrderDetails> {
    return this.httpService.get({ api: `${this.apiPath}/${orderId}` });
  }

  public getOrderPositions(orderMasterId: number): Observable<Position[]> {
    return this.httpService.get({ api: `${this.apiPath}/${orderMasterId}/positions` });
  }

  public getOrderSummaries(status?: TripStatus[]): Observable<OrderSummary[]> {
    return this.httpService.get({ api: `${this.apiPath}/summaries`, searchParameters: { status } });
  }
}
